/* eslint-disable no-param-reassign */
import { curry } from 'lib/util'
import remember from 'app/_shared/events/remember'
import { back, persistScroll } from 'app/_shared/events'
import detail from 'app/_shared/events/action/detail'
import { chain, platform } from 'app/_shared/events/util'
import update from 'app/_shared/events/util/update'
import action from 'app/_shared/events/action'
import { user } from 'app/_shared/events/pubsub'
import readAlerts from 'app/notification/event/alerts/read'
import readMessages from 'app/notification/event/messages/read'
import openAlert from 'app/notification/event/alerts/show'
import openMessage from 'app/notification/event/messages/show'
import updateAlert from 'app/notification/event/alerts/update'
import deleteAlert from 'app/notification/event/alerts/delete'
import setAlerts from 'app/notification/event/alerts/set'
import setMessages from 'app/notification/event/messages/set'
import updateAllAlerts from 'app/notification/event/alerts/updateAll'
import deleteAllAlerts from 'app/notification/event/alerts/deleteAll'
import clearAndReloadList from 'app/notification/event/clearAndReloadList'
import reloadList from 'app/notification/event/reloadList'

export default {
  onOpen: {
    getAlerts: readAlerts(null),
    getMessages: readMessages(null),
  },
  onPage: {
    setAlerts: setAlerts(null),
    setMessages: platform({
      web: setMessages(null),
      // #SG-41 - Setting messages for mobile freezes the list's data
      mobile: curry((m, c, e) => {}),
    }),
  },
  onClick: {
    openAlert: openAlert(null),
    openMessage: openMessage(null),
    updateAndBack: chain(
      updateAlert(null),
      back,
    ),
    deleteAndBack: chain(
      deleteAlert(null),
      back,
    ),
    updateAll: chain(
      updateAllAlerts(null),
      action,
    ),
    deleteAll: chain(
      curry(async (module, component, event) => {
        await deleteAllAlerts(
          () => reloadList('list', module, component, event),
          module,
          component,
          event,
        )
      }),
      update,
    ),
  },
  onClose: {
    back,
  },
  onScroll: {
    persistScrollAndRemember: chain(
      persistScroll,
      remember,
    ),
  },
  onActionClick: {
    redirectToOptions: detail,
  },
  list: {
    sub: user,
  },
  onPublication: {
    clearAndReloadList,
  },
}
